import React, { useContext } from "react";
import PropTypes from "prop-types";
import {useIntl, FormattedMessage} from 'react-intl';
import UserPrefsContext from "../../../context/UserPrefs/UserPrefsContext";

import { FormatAsThousands } from "../../../utils/Helpers/Format";

import Range from "../../shared/InputElements/Range";


const SlideMilesDrivenDaily = ({
  id = "miles-driven-daily-range",
  ...rest
}) => {
  const intl = useIntl()
  const userPrefs = useContext(UserPrefsContext);
  
  const label = <FormattedMessage
  id="evs.roundTripCommute"
  defaultMessage="Round Trip Commute"
  description="Round Trip Commute"
  />;

  const description = val => {
    return `${FormatAsThousands(val)} ${intl.formatMessage ? intl.formatMessage({ id: "vehicle.miles", defaultMessage: "miles"}) : "miles"}`;
  };

  return (
    <Range
      id={id}
      value={userPrefs.get("milesDrivenDaily")}
      label={label}
      rangeMin={1}
      rangeMax={150}
      rangeStep={1}
      description={description}
      ariaControls="electric-vehicles-catalog"
      handler={e => userPrefs.set({ milesDrivenDaily: e.target.value })}
      {...rest}
    />
  );
};

export default SlideMilesDrivenDaily;

SlideMilesDrivenDaily.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string,
  description: PropTypes.func
};
